<template>
    <div class="reports-disclaimer font-5" v-once>
        <div class="font-4">Please Note</div>
        <div v-if="paymentMessage">
            The payment of the revenues displayed for Ad Networks other than ironSource is subject to the Ad Networks' terms and conditions.
        </div>
        <div v-if="estimatedCurrencyConversion">
            Reports are estimated and subject to real-time currency conversion.
        </div>
        <div v-if="dateInUtc">
            All reports and dates are in UTC.
        </div>
        <div v-if="estimateTermsAndConditions" class="">
            All reports are estimates and subject to change in accordance to our <a :href="termsAndConditionsLink" target="_blank"> Terms &amp; Conditions.</a>
        </div>
        <div v-if="mediationMessage" class="ng-hide">
            * Mediation revenue is estimated based on 3rd party reporting; it is not paid by ironSource
        </div>
    </div>
</template>

<script>
import links from 'services/metaData/links';

export default {
    name: 'ReportsDisclaimer',
    props: {
        paymentMessage: {
            type: Boolean,
            default: false
        },
        estimatedCurrencyConversion: {
            type: Boolean,
            default: false
        },
        dateInUtc: {
            type: Boolean,
            default: false
        },
        estimateTermsAndConditions: {
            type: Boolean,
            default: false
        },
        mediationMessage: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        termsAndConditionsLink() {
            return links.termsAndConditions;
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/styleGuide";

.reports-disclaimer {
    color: $dark-300;

    a {
        color: $primary;
        text-decoration: none;
    }
}
</style>
